import React from 'react';
import Scale from './scale';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { H3Atom } from '@atoms/text-atoms/text-atoms';
import { SingleBarProps } from './single-bar.types';

const SingleBar: React.FC<SingleBarProps> = ({
  value,
  target,
  displayTitle = false,
  className,
}) => {
  if (typeof value === 'number' && typeof target === 'number') {
    return (
      <>
        {displayTitle ? <H3Atom>Target: {target}%</H3Atom> : null}
        <div className={className} data-testid="single-bar">
          <Scale />
          <div className="ruler-background" />
          <div className="target-bar" data-testid="bar-target" />
          <div className="value-bar" data-testid="bar-value" />
        </div>
      </>
    );
  } else {
    console.warn(
      `SingleBar received non valid props - value: '${value}' or target: '${target}'`
    );
    return null;
  }
};

const StyledSingleBar = styled(SingleBar)`
  height: 1.4rem;
  width: 14rem;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${vars.greyHavens};
  border-left: 0.5rem ${vars.greyHavens} solid;
  border-right: 0.5rem ${vars.greyHavens} solid;

  transform: ${({ displayVertical }) =>
    displayVertical ? 'rotate(270deg)' : 'none'};

  margin: ${({ displayVertical }) =>
    displayVertical ? '10rem 0 10rem 0' : 'none'};

  .value-bar,
  .target-bar {
    position: absolute;
  }
  .target-bar {
    width: ${({ target }) => target}%;
    height: 0.8rem;
    background: ${vars.graphLightBlue};
    z-index: 50;
    opacity: 0.8;
  }
  .value-bar {
    width: ${({ value }) => value}%;
    height: 0.4rem;
    background: ${vars.graphDarkBlue};
    z-index: 60;
  }
  ${Scale} {
    margin-left: -1px;
    margin-right: -1px;
    height: 100%;
  }
`;

export default StyledSingleBar;
